/**
 * Stylesheet Manager for safe CSS variable updates that comply with CSP
 * Manipulates an external stylesheet for CSS variables
 */

// Stylesheet URL - adjusted to match the actual path in HTML
const STYLESHEET_URL = `${process.env.BASE_URL}css/root-styles.css`;

/**
 * Find the external stylesheet by its href
 * @returns {CSSStyleSheet|null} The stylesheet object or null if not found
 */
function findStylesheet() {
  // Loop through all stylesheets to find our target by URL
  for (let i = 0; i < document.styleSheets.length; i++) {
    const sheet = document.styleSheets[i];
    // Check if this is our target stylesheet
    if (sheet.href && sheet.href.endsWith(STYLESHEET_URL)) {
      return sheet;
    }
  }
  return null;
}

/**
 * Update a CSS variable in the external stylesheet
 * @param {string} variable - The CSS variable name (including --)
 * @param {string} value - The value to set
 */
export default function updateCSSVariable(variable, value) {
  try {
    // Find our external stylesheet
    const sheet = findStylesheet();

    if (!sheet) {
      console.error(`Cannot find stylesheet with URL "${STYLESHEET_URL}"`);
      return;
    }

    // Get the rules from the stylesheet
    const rules = sheet.cssRules || sheet.rules;

    // Find the :root rule that should contain our variables
    let rootRule = null;
    for (let i = 0; i < rules.length; i++) {
      if (rules[i].selectorText === ':root') {
        rootRule = rules[i];
        break;
      }
    }

    if (rootRule) {
      // Update the existing CSS variable
      rootRule.style.setProperty(variable, value);
    } else {
      console.error(`:root rule not found in external stylesheet "${STYLESHEET_URL}"`);
    }
  } catch (error) {
    console.error('Failed to update CSS variable:', error);

    // If we have a security error due to CORS, inform the developer
    if (error.name === 'SecurityError') {
      console.error(
        `This appears to be a CORS issue.
        Ensure the stylesheet is served from the same origin or has proper CORS headers.`,
      );
    }
  }
}
